import Menu from "../menu/Menu.vue";
import Card from "../card/Card.vue";
import Carousel from "../carousel/Carousel.vue";
import Quote from "../quote/Quote.vue";
import Stats from "../stats/Stats.vue";
import {
    KinesisContainer,
    KinesisElement
} from 'vue-kinesis'




export default {
    name: "Alfred",
    components: {
        Menu,
        Card,
        Carousel,
        KinesisContainer,
        KinesisElement,
        Quote,
        Stats
    },
    created: function () {
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 500)
    },
    data: function () {
        return {
            startStats: [{
                num: 4,
                label: "months"
            }, {
                num: 106,
                label: "pages"
            }, {
                num: 432,
                label: "cups of coffee"
            }],
            slides: [{
                quote: "“I framtiden kommer detta bli ett problem för den kunden”",
                name: "Anonymous",
                title: "User Interviews"
            }, {
                quote: "“Den följer inte riktigt min logik när jag ska sätta upp allt.”",
                name: "Anonymous",
                title: "User Interviews"
            }, {
                quote: "“I framtiden kommer detta bli ett problem för den kunden”",
                name: "Anonymous",
                title: "User Interviews"
            }]
        }
    }
}